export const setConnectionStatus = (name, data) => dispatch => {
  dispatch({ type: `SET_${name}_CONNECTION_STATUS`, payload: { name, data } })
}

// true = connected with WS
// false = disconnected with WS for an error reason
// null = disconnected with WS for a normal reason